<template>
    <div class="select-none">
      <div v-if="isBasic">{{ description }}</div>
      <div
        v-else
        class="relative"
        :class="{ 'h-12 overflow-hidden cursor-pointer': !isOpen, 'whitespace-pre-line': isOpen }"
        @click="isOpen = !isOpen"
      >
        {{ description }}
        <div class="email-overlay absolute inset-0" v-if="!isOpen"></div>
      </div>
    </div>
</template>

<script>
const MAX_BASIC_HEIGHT = 68;

export default {
  props: {
    description: String,
  },

  data() {
    return {
      isOpen: false,
      isBasic: true
    };
  },

  watch: {
    description() {
      this.determineIsBasic();
    }
  },

  mounted() {
    this.determineIsBasic();
  },

  methods: {
    determineIsBasic() {
      this.isBasic = !(
        this.$el.clientHeight >= MAX_BASIC_HEIGHT ||
        this.description.includes("\n")
      );
    }
  }
};
</script>
